import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

/** /demo - one link that drops a visitor into the shared demo closet. */
export default function DemoPage() {
  const { demoLogin, user, logout } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        if (user && !user.is_demo) await logout();   // a signed-in owner opening the link gets the demo, not their own closet
        await demoLogin();
        if (alive) navigate("/home", { replace: true });
      } catch (e) {
        if (alive) setError(e?.response?.data?.detail || "The demo isn't available right now");
      }
    })();
    return () => { alive = false; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="min-h-dvh bg-background flex items-center justify-center p-6" data-testid="demo-page">
      {error ? <p className="text-sm text-muted-foreground">{error}</p>
        : <p className="inline-flex items-center gap-2 text-sm text-muted-foreground"><Loader2 className="h-4 w-4 animate-spin" /> Opening the demo closet…</p>}
    </div>
  );
}
